import React from 'react';
import { Avatar, Stack, Typography } from '@mui/material';
import { Person as PersonIcon } from '@mui/icons-material';
import { useQuery } from 'react-query';
import { defineMessages, useIntl } from 'react-intl';
import API, { Types, useAuth } from '@wheeebo/polaris-api';
import { SquareChip } from '../chip';
import { CircleLoader, LoadError } from '../loader';
const msgs = defineMessages({
    chipPending: {
        id: 'pages.member.group.MemberManagementCard.chip.pending',
        defaultMessage: 'Invitation Pending',
    },
    chipDeclined: {
        id: 'pages.member.group.MemberManagementCard.chip.declined',
        defaultMessage: 'Invitation Declined',
    },
});
function GroupMemberPanel({ groupMember, groupId, memberId, callerGroupMember, ...props }) {
    const intl = useIntl();
    const { account } = useAuth();
    const { data, isLoading, isError } = useQuery(groupId && memberId ? API.GroupMembers.getKey(groupId, memberId) : '', () => (groupId && memberId ? API.GroupMembers.get(groupId, memberId) : undefined), { enabled: !groupMember && !!groupId && !!memberId });
    if (!groupMember) {
        if (isLoading) {
            return React.createElement(CircleLoader, null);
        }
        else if (isError) {
            return React.createElement(LoadError, null);
        }
    }
    const content = groupMember || data;
    const nameTmp = content?.member.name || content?.member.id || '';
    const name = nameTmp.length > 12 ? nameTmp.slice(0, 12) + '...' : nameTmp;
    const isGroupOwner = callerGroupMember?.role === Types.GroupMemberOwnerRole &&
        callerGroupMember?.invitationStatus === Types.InvitationStatusAccepted;
    return (React.createElement(Stack, { direction: "row", sx: { display: 'flex', alignItems: 'center', gap: 1 }, ...props },
        React.createElement(Avatar, { src: content?.member.avatarUrl, sx: { width: 32, height: 32, backgroundColor: 'transparent' } },
            React.createElement(PersonIcon, { color: "disabled" })),
        React.createElement(Typography, { variant: "body2" }, name),
        account?.id === content?.member.id && React.createElement(SquareChip, { label: "You", color: "primary" }),
        React.createElement(SquareChip, { label: content?.role }),
        account?.id !== content?.member.id && isGroupOwner && content?.invitationStatus === 'PENDING' ? (React.createElement(SquareChip, { label: intl.formatMessage(msgs.chipPending), color: "warning" })) : content?.invitationStatus === Types.InvitationStatusDeclined ? (React.createElement(SquareChip, { label: intl.formatMessage(msgs.chipDeclined), color: "error" })) : null));
}
export default React.memo(GroupMemberPanel);
